import React from 'react';
import { Modal } from 'react-bootstrap';
import { i18n } from 'core/i18n';
const { FormattedText, formatText } = i18n;
import OtpTransferModalHelpPoints from 'componentsV2/OTPTransfer/OTPTransferModalHelpPoints.jsx';
import { recordEvent } from 'utilities/uTagging';

const helpPoints = [
    {
        id: '01',
        icon: 'transfer-blue',
        title: <FormattedText value="otpCode-helpinfoTitleitem1" />,
        text: <FormattedText value="otpCode-helpinfoDescriptionitem1" />,
    },
    {
        id: '02',
        icon: 'document-blue',
        title: <FormattedText value="otpCode-helpinfoTitleitem2" />,
        text: <FormattedText value="otpCode-helpinfoDescriptionitem2" />,
    },
    {
        id: '03',
        icon: 'upload-cloud-blue',
        title: <FormattedText value="otpCode-helpinfoTitleitem3" />,
        text: <FormattedText value="otpCode-helpinfoDescriptionitem3" />,
    },
];

const OTPTransferHelpModal = ({ showModal, hideModal }) => {
    const onClickUnderstandButton = event => {
        hideModal(event);
        recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
            accionEvento: 'otp-ibanid/modal-te-ayudamos',
            etiquetaEvento: 'entendido',
            categoriaEvento: 'eventos IBAN OTP',
        });
    };
    const onClickCloseCross = event => {
        hideModal(event);
        recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
            accionEvento: 'otp-ibanid/modal-te-ayudamos',
            etiquetaEvento: 'cerrar',
            categoriaEvento: 'eventos IBAN OTP',
        });
    };
    return (
        <div>
            <Modal
                show={showModal}
                onHide={hideModal}
                dialogClassName="otp-help-modal"
                backdrop="static"
                keyboard={false}
                animation={false}
            >
                <Modal.Body>
                    <h3 className="font-heading3">{formatText('otpCode-helpinfoTitle')}</h3>
                    <i onClick={onClickCloseCross} className="otp-help-points-icon icon--close" />
                    <div className="otp-help-modal-content">
                        <div className="icon-container">
                            <i className="icons icons--icon-search-document" />
                            <p className="font-paragraph2">{formatText('otpCode-helpinfoSubTitle')}</p>
                        </div>
                        <OtpTransferModalHelpPoints helpPoints={helpPoints} />
                    </div>
                    <div className="form__buttons">
                        <button className="form__button form__button-transparent" onClick={hideModal}>
                            {formatText('otpCode-helpinfoCancel')}
                        </button>
                        <button className="form__button form__button-secondary" onClick={onClickUnderstandButton}>
                            {formatText('otpCode-helpinfoOk')}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default OTPTransferHelpModal;
